/**
 * 功能: 报告中插入表说附件的列表
 */
<template lang="pug">
  el-table(
    ref="tableRef"
    :data="tableData")
    el-table-column(
      prop="title"
      label="标题"
      width="200"
      show-overflow-tooltip)
    //- el-table-column(
    //-   prop="industry"
    //-   label="行业"
    //-   width="120"
    //-   show-overflow-tooltip)
    //-   template(slot-scope="scope")
    //-     span(v-if="scope.row.industry" v-html="scope.row.industry.join('<br />')")
    el-table-column(
      prop="source"
      label="来源"
      width="110"
      align="center"
      show-overflow-tooltip)
      template(slot-scope="scope")
        span {{ scope.row.source }}
    el-table-column(
      prop="status"
      label="状态"
      width="90"
      align="center")
      template(slot-scope="scope")
        span {{ scope.row.status | status }}
    el-table-column(
      prop="isPolicy"
      label="政策"
      width="50"
      align="center")
      template(slot-scope="scope")
        span {{ scope.row.isPolicy | whether}}
    el-table-column(
      prop="pureText"
      label="内容"
      show-overflow-tooltip)
    el-table-column(
      label="操作"
      width="80"
      align="center")
      template(slot-scope="scope")
        el-button(:size="GLOBAL.SIZE_OF_INPUTBOX" @click="handleInsert(scope.row)") 插入
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {}
  },
  methods: {
    handleInsert (tableInfo) {
      tableInfo._class = 1
      this.$emit('getInsertData', tableInfo, () => {
        this.$message({
          type: 'success',
          message: '临时插入附件成功！'
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
